module.exports = __webpack_public_path__ + "static/media/MC1.ef43d66c.jpeg";